import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { KanbanViewCardI } from '../../models/kanban-view/kanban-contacts-view';
import { MatCheckbox } from '@angular/material/checkbox';
import * as moment from 'moment';

@Component({
  selector: 'anterasoftware-contacts-kanban-card-view',
  templateUrl: './contacts-kanban-card-view.component.html',
  styleUrls: ['./contacts-kanban-card-view.component.scss']
})
export class ContactsKanbanCardViewComponent implements OnInit {

  @Output() public onCardDetailsChange: EventEmitter<any> = new EventEmitter();
  @Output() public editCardDetails: EventEmitter<any> = new EventEmitter();
  @Input() public dateFormatString: string = 'YYYY-MM-DD';
  @Input() public timeFormatString: string = 'hh:mm a';
  @Input() public cardDetails: KanbanViewCardI = {
    select: false,
    id: '',
    title: '',
    accountName: '',
    contactName: '',
    phone: '',
    email: '',
    created: '',
  };
  dueColor: string = '';
  dueFontColor: string = '';
  
  constructor() { }

  ngOnInit(): void {
    if (this.cardDetails.created && this.cardDetails.created !== '0000-00-00') {
      let cardDate = moment(this.cardDetails.created).endOf('day');
      let curDate = moment().endOf('day');
      let diff = cardDate.diff(curDate, 'hours');
      switch(true) {
        // red past due or due today
        case diff < 0:
          this.dueColor = 'red';
          this.dueFontColor = '#ffffff';
          break;
        //due today
        case diff == 0:
          this.dueColor = 'orange';
          this.dueFontColor = '#ffffff';
          break;
        // tomorrow
        case diff >= 24 && diff <= 24*2:
          this.dueColor = 'yellow';
          break;
        // this week
        case diff >= 24*2 && diff <= 24*7:
          this.dueColor = 'green';
          this.dueFontColor = '#ffffff';
          break;
        // next week
        case diff >= 24*7 && diff <= 24*14:
          this.dueColor = 'blue';
          this.dueFontColor = '#ffffff';
          break;
        // this month
        case diff >= 24*14 && diff <= 24*30:
          this.dueColor = 'black';
          this.dueFontColor = '#ffffff';
          break;
        default:
          this.dueColor = 'gray';
          break;              
      }
    }
  }
    

  public onCheckBoxSelected(event: MatCheckbox): void {
    this.onCardDetailsChange.emit(this.cardDetails);
  }
  
  public getDateFormat(date :any, includeTime = false, excludeTime = false, convert = false) {
    if(date == null || date == '' || date == '0000-00-00 00:00:00' || date == '0000-00-00' || date == '0000-00-00' || (String(date).indexOf("0000") > -1 && String(date).indexOf("+0000") < 0 )){
        return '';
    }
    if(convert){
      if(includeTime){
    return moment(moment.utc(date).local().toDate()).format(this.dateFormatString+' '+this.timeFormatString);
      }else{
    if(String(date).length > 10 && !excludeTime){
        return moment(moment.utc(date).local().toDate()).format(this.dateFormatString+' '+this.timeFormatString);
    }else{
        return moment(moment.utc(date).local().toDate()).format(this.dateFormatString);
    }
      }          
    }else{
      if(includeTime){
    return moment(date).format(this.dateFormatString+' '+this.timeFormatString);
      }else{
    if(String(date).length > 10 && !excludeTime){
        return moment(date).format(this.dateFormatString+' '+this.timeFormatString);
    }else{
        return moment(date).format(this.dateFormatString);
    }
      }      
    }
  }
  
  public editCard(lead: any) {
    this.editCardDetails.emit(lead);
  }
}
